import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/tesla/share.png'
import _imports_1 from '@/assets/images/inviteCodePersonal/share-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-7c8b7272"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "pageShare-icon"
}, null, -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "count" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*1", -1))
const _hoisted_9 = { class: "tips" }
const _hoisted_10 = { class: "banner-tc" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-tc-divider" }, null, -1))
const _hoisted_12 = { class: "reward-wrapper" }
const _hoisted_13 = { class: "reward-list" }
const _hoisted_14 = { class: "reward-item spec" }
const _hoisted_15 = { class: "reward-item-label" }
const _hoisted_16 = { class: "reward-item-value" }
const _hoisted_17 = { class: "reward-item-label" }
const _hoisted_18 = { class: "reward-item-value" }
const _hoisted_19 = { class: "reward-item-value-ccy" }
const _hoisted_20 = { class: "reward-item-value-count" }
const _hoisted_21 = { class: "reward-item-value-unit" }
const _hoisted_22 = { class: "invite-detail" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*2", -1))
const _hoisted_24 = { class: "invite-agree" }
const _hoisted_25 = {
  key: 0,
  class: "invite-agree-checkbox"
}
const _hoisted_26 = {
  key: 0,
  class: "invite-btn"
}
const _hoisted_27 = {
  key: 1,
  class: "invite-wrapper"
}
const _hoisted_28 = { class: "invite-code" }
const _hoisted_29 = { class: "invite-code-label" }
const _hoisted_30 = { class: "invite-code-value" }
const _hoisted_31 = ["data-clipboard-text"]
const _hoisted_32 = { class: "invite-group" }
const _hoisted_33 = { class: "invite-btn" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "photo-icon" }, null, -1))
const _hoisted_35 = { class: "invite-btn" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "link-icon" }, null, -1))
const _hoisted_37 = { class: "my" }
const _hoisted_38 = { class: "my-wrapper" }
const _hoisted_39 = { class: "my-wrapper-content" }
const _hoisted_40 = { class: "my-wrapper-content-title" }
const _hoisted_41 = { class: "my-wrapper-content-count" }
const _hoisted_42 = { class: "my-wrapper-tips" }
const _hoisted_43 = { class: "guide" }
const _hoisted_44 = { class: "guide-wrapper" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "tips" }
const _hoisted_47 = { class: "share-header" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "share-header-bg"
}, null, -1))
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "share-title" }
const _hoisted_51 = { class: "share-subtitle" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "送你", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "count" }, "9折", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Fusion Bank "),
    /*#__PURE__*/_createElementVNode("span", { class: "count" }, "10% off")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Tesla Loan interest"),
  /*#__PURE__*/_createElementVNode("p", null, "discount coupon for you")
], -1))
const _hoisted_55 = { class: "share-about" }
const _hoisted_56 = { class: "share-inviteCode" }
const _hoisted_57 = { class: "share-content" }
const _hoisted_58 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_checkbox = _resolveComponent("t-checkbox")!
  const _component_my_button = _resolveComponent("my-button")!
  const _component_common_title = _resolveComponent("common-title")!
  const _component_LangVue = _resolveComponent("LangVue")!
  const _directive_stat = _resolveDirective("stat")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.shareVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "pageShare",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
          }, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('分享')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["banner", { eng: _ctx.isEng }])
        }, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodePersonal/logo${_ctx.isEng ? '_en' : ''}.png`),
            alt: "",
            class: "logo"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('邀好友申请')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Tesla专享贷款')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('月赚高达')), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('5,700港币')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('现金奖赏')), 1),
              _hoisted_8
            ])
          ]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('借定唔借？还得到先好借！')), 1),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewContract('CreditLineKFS'))),
              class: "banner-tc-text"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('产品资料概要')), 1)
            ])), [
              [_directive_stat, { event: 'teslaCreditLineKFS', num: '1' }]
            ]),
            _hoisted_11,
            _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewContract('CreditLineTC'))),
              class: "banner-tc-text"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('条款及细则')), 1)
            ])), [
              [_directive_stat, { event: 'teslaCreditLineTC', num: '1' }]
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["invite", { eng: _ctx.isEng }])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('邀请好友申请Tesla专享贷款奖赏表')), 1),
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('每月累计成功邀请人数')), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('推荐奖赏')), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configInfo.rewardList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "reward-item",
                  key: item
                }, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.label), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.ccy), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.value), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('/人')), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.$t('通过你的邀请，好友可获9折Tesla贷款减息券')), 1),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            (!_ctx.isSign && !_ctx.inviteCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("div", { class: "invite-agree-checkbox-tips" }, _toDisplayString(_ctx.$t('请先阅读并同意活动条款或细则')), 513), [
                    [_vShow, _ctx.isShowAgreeTips]
                  ]),
                  _createVNode(_component_t_checkbox, {
                    modelValue: _ctx.isAgree,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isAgree) = $event)),
                    theme: "highlight"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('本人已阅读并同意')), 1),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkProto && _ctx.checkProto(...args)))
              }, _toDisplayString(_ctx.$t('富融银行Tesla专享贷款邀请好友赚现金活动')), 1),
              _createTextVNode(_toDisplayString(_ctx.$t('的条款及细则')), 1)
            ])
          ]),
          (!_ctx.inviteCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_my_button, {
                  text: _ctx.$t('立即邀请'),
                  onClick: _ctx.handleClick
                }, null, 8, ["text", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('贷款邀请码')), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.inviteCode), 1),
                  _createElementVNode("i", {
                    class: "invite-code-copy",
                    "data-clipboard-text": _ctx.inviteCode,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
                  }, null, 8, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_my_button, {
                      text: _ctx.$t('图片邀请'),
                      onClick: _ctx.handlePhoto,
                      size: "small"
                    }, {
                      before: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    }, 8, ["text", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_my_button, {
                      text: _ctx.$t('链接邀请'),
                      onClick: _ctx.handleLink,
                      size: "small"
                    }, {
                      before: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    }, 8, ["text", "onClick"])
                  ])
                ])
              ]))
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_common_title, {
          title: _ctx.$t('我的推荐奖赏')
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t('您当前成功获得的奖赏')), 1),
            _createElementVNode("p", _hoisted_41, "HKD " + _toDisplayString(_ctx.awardAmt), 1)
          ]),
          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('*奖赏发放后数据才会更新喔')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_common_title, {
          title: _ctx.$t('邀请攻略')
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configInfo.guideList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "guide-step",
              key: index
            }, [
              _createElementVNode("img", {
                src: require(`@/assets/images/inviteCodePersonal/step${index + 1}_${_ctx.lang}.png`),
                alt: ""
              }, null, 8, _hoisted_45),
              _createElementVNode("p", null, _toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createVNode(_component_common_title, {
          title: _ctx.$t('备注')
        }, null, 8, ["title"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configInfo.tipsList, (item) => {
          return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["share", { eng: _ctx.isEng }]),
      ref: "shareRef"
    }, [
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("img", {
          src: require(`@/assets/images/inviteCodePersonal/logo${_ctx.isEng ? '_en' : ''}.png`),
          alt: "",
          class: "share-logo"
        }, null, 8, _hoisted_49),
        _createVNode(_component_LangVue, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('我在富融银行')), 1),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _hoisted_53,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Tesla贷款减息券')), 1)
            ])
          ]),
          en: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        }),
        _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.$t('Tesla专属贷款邀请码')), 1),
        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.inviteCode), 1)
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("img", {
          src: require(`@/assets/images/inviteCodePersonal/share-content_${_ctx.lang}.png`),
          alt: ""
        }, null, 8, _hoisted_58),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('阁下首次申请Tesla贷款时填入以上贷款邀请码即代表阁下同意受本条款及细则约束。请细阅有关条款及细则。')), 1)
      ])
    ], 2)
  ], 64))
}